import m from "mithril";
import selectbox from "./selectbox";

const _getLabel = function (props) {
    let label = props.firstLabel;
    label = props != null ? '' + label : '';
    for (let i = 0, l = props.options.length; i < l; i++) {
        const option = selectbox.normalizeOption(props.options[i]);
        if (option.value === props.value) {
            label = '' + option.label;
            break;
        }
    }
    return label.trim();
};

const ns = ' fancyselect';

/*
 Custom Props:
 * className (String) *Optional*
 * wrapperAttrs (Object) *optional*

 * +selectbox props
 */
const fancySelectbox = {

    controller: function (/*props*/) {
        const ctrl = this;
        ctrl.isFocused = false;

        ctrl.setElement = function (elm) {
            ctrl.elm = elm;
        };
        const focusClass = ns.slice(1) + '--is-focused';
        ctrl.focusClass = function (focusState) {
            ctrl.isFocused = focusState;
            ctrl.elm.classList[focusState ? 'add' : 'remove'](focusClass);
        };
    },

    view: function (ctrl, props) {
        const wrapperAttrs = Object.assign(props.wrapperAttrs || {}, {
            className: (props.className || '') + ns +
            (props.disabled ? ns + '--is-disabled' : '') +
            (ctrl.isFocused ? ns + '--is-focused' : ''),
            config: ctrl.setElement,
        });
        delete props.wrapperAttrs;

        props.className = ns + '__select'; // for the <select>
        props.style = (props.style ? props.style + ';' : '') +
            'position:absolute;bottom:0;left:0;top:auto;right:auto;' +
            'width:100%;height:100%;' +
            'margin:0;padding:0;border:0;' +
            'opacity: 0';

        const fancyLabel = _getLabel(props) || '\u00a0 \u00a0 \u00a0';

        const onfocus = props.onfocus;
        props.onfocus = function (e) {
            ctrl.focusClass(true);
            onfocus && onfocus.call(this, e);
        };
        const onblur = props.onblur;
        props.onblur = function (e) {
            ctrl.focusClass(false);
            onblur && onblur.call(this, e);
        };

        if (props.bluronchange !== false) {
            const onchange = props.onchange;
            props.onchange = function (e) {
                onchange && onchange.call(this, e);
                this.blur();
            };
        }

        return (
            m('span', wrapperAttrs,
                fancyLabel,
                m(selectbox, props)
            )
        );
    },

};

export default fancySelectbox;
